<template>

<div id="loading" >
    <div v-show="loadGlobal.show == true && loadGlobal.enable == true">
      <center v-show="loading.page == true || loading.ajax == true" class="carregando">
        <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
      </center>
    </div>
</div>

</template>

<script>

import { mapState, mapMutations } from 'vuex'

export default {

  data: () => ({
    percent: 0,
    show: false, //carregamento das páginas
    canSuccess: true,
    duration: 3000,
    height: '2px',
    color: '#77b6ff',
    failedColor: 'red'
  }),

  computed:{

    ...mapState('config', ['loadGlobal', 'loading'])

  },

  methods: {

    ...mapMutations('config', ['SET_LOADING']),

    start () {
      this.SET_LOADING({ page: true })
      this.show = true
      this.canSuccess = true
      if (this._timer) {
        clearInterval(this._timer)
        this.percent = 0
      }
      this._cut = 10000 / Math.floor(this.duration)
      this._timer = setInterval(() => {
        this.increase(this._cut * Math.random())
        if (this.percent > 95) {
          this.finish()
        }
      }, 100)
      return this
    },
    set (num) {
      this.SET_LOADING({ page: true })
      this.show = true
      this.canSuccess = true
      this.percent = Math.floor(num)
      return this
    },
    get () {
      return Math.floor(this.percent)
    },
    increase (num) {
      this.percent = this.percent + Math.floor(num)
      return this
    },
    decrease (num) {
      this.percent = this.percent - Math.floor(num)
      return this
    },
    finish () {
      this.percent = 100
      this.hide()
      return this
    },
    pause () {
      clearInterval(this._timer)
      return this
    },
    hide () {
      clearInterval(this._timer)
      this._timer = null
      setTimeout(() => {
        this.SET_LOADING({ page: false })
        this.show = false
        this.$nextTick(() => {
          setTimeout(() => {
            this.percent = 0
          }, 200)
        })
      }, 500)
      return this
    },
    fail () {
      this.canSuccess = false
      return this
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/especiais/Loading.vue